import { useState } from "react";
import { type SxProps, type Theme } from "@mui/material/styles";

import { Button } from "ui/button";
import SmsSimulatorViewPersona from "containers/sms-simulator/sms-simulator-personas/components/persona-modal/view-persona/sms-simulator-view-persona";

import { SmsSimulatorPersonaAttributes } from "containers/sms-simulator/sms-simulator.types";

const PERSONA_BADGE_SX: SxProps<Theme> = (theme) => ({
  boxShadow: theme.shadows[0],
  backgroundColor: "transparent",
  color: theme.palette.grey[600],
});

interface SmsSimulatorPersonaBadgeProps {
  persona: SmsSimulatorPersonaAttributes;
}

const SmsSimulatorPersonaBadge = ({ persona }: SmsSimulatorPersonaBadgeProps) => {
  const [isViewPersonaModalOpen, setIsViewPersonaModalOpen] = useState(false);

  const GRADE_COLORS = {
    10: "text-lime-600",
    11: "text-warning-500",
    12: "text-red-500",
  } as const;

  const getGradeText = (grade: number) => {
    const gradeColorClass = GRADE_COLORS[grade as keyof typeof GRADE_COLORS];
    if (!gradeColorClass) {
      return null;
    }
    return <span className={gradeColorClass}>{`${grade}th grade`}</span>;
  };

  return (
    <div>
      <Button
        sx={PERSONA_BADGE_SX}
        variant="contained"
        size="small"
        onClick={() => setIsViewPersonaModalOpen(true)}>
        <div>{persona.name}</div>
        <div>({persona.profileType})</div>
        {getGradeText(persona.grade) && <div>{getGradeText(persona.grade)}</div>}
      </Button>
      {isViewPersonaModalOpen && (
        <SmsSimulatorViewPersona onClose={setIsViewPersonaModalOpen} persona={persona} />
      )}
    </div>
  );
};

export default SmsSimulatorPersonaBadge;
